import { BannerService } from './../../service/banner.service';
import { Banner } from './../../model/banner';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.css']
})
export class HomeBannerComponent implements OnInit {

  public banners: Observable<Banner[]>;

  constructor(private service: BannerService,private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.banners = this.service.listar();
  }

  sanitizer(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home-banner/home-banner.component.ts